import { render, staticRenderFns } from "./LogView.vue?vue&type=template&id=ffa0d1a0&scoped=true&"
import script from "./LogView.vue?vue&type=script&lang=js&"
export * from "./LogView.vue?vue&type=script&lang=js&"
import style0 from "./LogView.vue?vue&type=style&index=0&id=ffa0d1a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa0d1a0",
  null
  
)

export default component.exports